var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLefrMirror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2032 36.8012C42.9676 36.8012 44.2986 36.3435 45.0554 35.4777C45.8699 34.5428 45.9004 33.3239 45.8428 32.6817C45.3314 29.6231 44.5288 26.6231 43.4773 23.9051C41.6553 19.2001 40.7478 18.549 35.9998 18.549C29.86 18.549 19.5767 22.1097 13.0746 26.4847C11.3339 27.6574 10.9715 29.098 11.8249 31.4558C12.5225 33.3896 14.0414 35.5061 14.8237 36.23C14.927 36.324 15.5332 36.7906 17.5499 36.8012H41.2032ZM56 40.221L47.6572 50L44.8176 47.447L46.9427 44.9562L41.8832 40.315C41.658 40.3275 41.4446 40.3487 41.2059 40.3487H17.5457C15.2547 40.3381 13.6342 39.8609 12.5861 38.8886C11.3365 37.7355 9.52467 35.108 8.6594 32.7111C6.86284 27.7471 9.07595 24.9617 11.2484 23.4998C18.328 18.7328 29.2005 15 36.0024 15C42.5266 15 44.4552 16.9835 46.6193 22.5702C47.7605 25.5224 48.6292 28.7672 49.2015 32.2179C49.2404 32.6668 49.2269 33.0943 49.2049 33.5166L54.0629 38.3422L56 40.221Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLefrMirror);
export default __webpack_public_path__ + "static/media/lefr-mirror.76f4c496cf4e8d7734fa12424753b02b.svg";
export { ForwardRef as ReactComponent };